import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import { Button, TableCell, Grid } from "@material-ui/core";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";
import { NavLink } from "react-router-dom";

const EMPTY_VALUE = '--';
const StyledTableCell = styled(TableCell)`
  &&&& {
    min-width: 275px;
  }`;
const SelectedNoItemGrid = styled(Grid)`
  &&&& {

    padding: 12px;
    background-color: rgb(242, 242, 242);
    font-family: "Roboto Medium", "Roboto Regular", Roboto;
    font-weight: 500;
    font-style: normal;
    font-size: 17px;
    color: rgb(153, 153, 153);
    width: 1500px;
  }`;
const NewButton = styled(Button)`
  && {
    margin: 0 0 -4px 4px;
    padding: 8px 8px 0px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;
export const VerticalDivider = styled.div`
height: 34px;
border-right: 1px solid #cccccc;
`;

const EmptyListDiv = styled.div`
  && {
    margin-top: 17px,
    margin-bottom: 17px
  }
`;


export class GuestTable extends Component {
  tableColumns = [
    {
      id: 'contactfirstName',
      label: 'Name',
      numeric: false,
      isString: true,
      isDateField: false,
      sortOverride:'contact.firstName',
      dataField: 'contact.firstName',
      secondaryDataField: 'contact.lastName'
    },
    {
      id: 'contactcompanyname',
      label: 'Company',
      numeric: false,
      isString: true,
      isDateField: false,
      dataField: 'contact.company.name'
    },
    {
      id: 'contactEmail',
      label: 'Email',
      numeric: false,
      isString: true,
      isDateField: false,
      dataField: 'contact.email'
    },
    {
      id: 'dealCount',
      label: 'No. of Assigned Deals',
      numeric: true,
      isString: false,
      isDateField: false,
      dataField: 'dealCount'
    },
    {
      id: 'actions',
      label: ' ',
      numeric: true,
      isString: false,
      isDateField: false,
      dataField: '',
      width: 320,
      cell: ({ data }) => (
        <StyledTableCell>
          <Grid container direction="row" justify="flex-start" alignItems="right" spacing={8}>
            <Grid item><NewButton variant="contained" onClick={ () => this.props.deleteGuest(data)}>Delete</NewButton></Grid>
            <Grid item><VerticalDivider /></Grid>
            <Grid item><NavLink exact to={`/admin/guestSettings/${data.id}`}><NewButton>Manage Permissions</NewButton></NavLink></Grid>
          </Grid>
        </StyledTableCell>
      )
    },
  ];

  render() {
    if(!this.props.records) return null;

    if(this.props.records.length == 0) return (
      <EmptyListDiv>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8} style={{paddingBottom:"8px"}}>
          <SelectedNoItemGrid container item>{`No guests found`}</SelectedNoItemGrid>
        </Grid>
    </EmptyListDiv>
    )
    return (
      <EnhancedTable
        columnDefinitions={this.tableColumns}
        rows={this.props.records}
        orderBy={this.tableColumns[1]}
        order={EnhancedTable.ASC_ORDER}
        shouldHideConfig="true"
        shouldHideExport="true"
      />
    );
  }
}

GuestTable.propTypes = {
  deleteGuestGroup: PropTypes.func.isRequired,
  manageGuestGroup: PropTypes.func.isRequired
};

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(GuestTable);
